const phone = function (phone) {
  const reg = /^1[3456789]\d{9}$/
  if (!(reg.test(phone))) {
    return '手机号码不正确'
  }
}
const mobiles = function (mobile) {
  const reg = /^1[3456789]\d{9}$/
  if (!(reg.test(mobile))) {
    return false
  } else {
    return true
  }
}

const idCard = function (idCard) {
  const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
  if (!(reg.test(idCard))) {
    return false
  } else {
    return true
  }
}

const pwd = function (pwd) {
  const reg = /^.{6,20}$/
  if (!(reg.test(pwd))) {
    return '密码由6-20位组成'
  }
}
const email = function (email) {
  const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
  if (!(reg.test(email))) {
    return '邮箱格式不正确'
  }
}

export {phone, pwd, email, mobiles, idCard}



// WEBPACK FOOTER //
// ./src/utils/phone.js